var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoTutorials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 0H15.6094C14.7788 0 14.0295 0.35312 13.5 0.916418C12.9705 0.352591 12.2212 0 11.3906 0H0V19.0944H6.06287C7.31004 21.9782 10.174 24.0005 13.5 24.0005C16.826 24.0005 19.69 21.9782 20.9371 19.0944H27V0ZM25.418 17.5062H21.4376C21.5462 16.9757 21.6032 16.4272 21.6032 15.865C21.6032 15.2276 21.5299 14.6076 21.3912 14.012H23.2295V12.4238H20.8417C20.5374 11.7721 20.1498 11.1675 19.6921 10.6238H23.2295V9.03554H17.8986C16.8397 8.34571 15.6115 7.89729 14.291 7.76865V2.91179C14.291 2.18225 14.8822 1.58825 15.6094 1.58825H25.418V17.5062ZM13.5 22.4118C9.90404 22.4118 6.97834 19.4746 6.97834 15.8645C6.97834 12.2544 9.90404 9.31719 13.5 9.31719C17.096 9.31719 20.0217 12.2544 20.0217 15.8645C20.0217 19.4746 17.096 22.4118 13.5 22.4118ZM1.58203 1.58825H11.3906C12.1178 1.58825 12.709 2.18172 12.709 2.91179V7.76812C11.3885 7.89729 10.1603 8.34571 9.10143 9.03501H3.77051V10.6233H7.3074C6.8502 11.167 6.46207 11.7716 6.15779 12.4233H3.76998V14.0115H5.6083C5.46961 14.6071 5.39578 15.2271 5.39578 15.8645C5.39578 16.4267 5.45273 16.9752 5.56137 17.5057H1.58203V1.58825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77051 5.64746H10.5205V7.23571H3.77051V5.64746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4795 5.64746H23.2295V7.23571H16.4795V5.64746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2705 16.5529V15.1774L11.7914 12.0015L10.6049 12.6892V19.0406L11.7914 19.7283L17.2705 16.5523V16.5529ZM12.1869 14.0646L15.2929 15.8651L12.1869 17.6657V14.0651V14.0646Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTutorials);
export default __webpack_public_path__ + "static/media/video-tutorials.319c4a19e4f5764267ebbe4acb626cc0.svg";
export { ForwardRef as ReactComponent };